"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBApartmentPositive = function SvgBApartmentPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M62.893 60.314a2.262 2.262 0 01-2.262-2.262v-6.031a2.262 2.262 0 014.523 0v6.031a2.262 2.262 0 01-2.261 2.262z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M62.855 43.479a2.262 2.262 0 01-2.262-2.262V27.141a2.262 2.262 0 012.262-2.261h39.204a2.262 2.262 0 012.262 2.261v13.337a2.262 2.262 0 01-4.524 0V29.403h-34.68V41.24a2.262 2.262 0 01-2.262 2.239zM116.316 42.74a2.262 2.262 0 01-2.262-2.262V23.605a2.262 2.262 0 014.524 0v16.873a2.262 2.262 0 01-2.262 2.262zM98.516 143.502a2.262 2.262 0 01-2.262-2.261v-19.052H68.698v18.961a2.262 2.262 0 01-2.262 2.262H12.96a5.813 5.813 0 01-5.805-5.805V23.613a2.262 2.262 0 014.523 0v113.994c0 .708.574 1.281 1.282 1.281h51.214v-18.96a2.262 2.262 0 012.262-2.263h32.08a2.262 2.262 0 012.261 2.262v19.037l11.965-.076c.71 0 1.289-.571 1.297-1.281V116.42a2.262 2.262 0 014.524 0v21.186a5.82 5.82 0 01-5.806 5.805l-14.226.09h-.015z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M82.48 143.412a2.262 2.262 0 01-2.262-2.262v-21.223a2.262 2.262 0 014.523 0v21.223a2.262 2.262 0 01-2.261 2.262z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M82.841 122.189H66.436a2.262 2.262 0 010-4.524h16.405a2.262 2.262 0 010 4.524z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M48.598 132.85a2.262 2.262 0 01-2.262-2.262V13.729a2.262 2.262 0 014.524 0v116.859a2.262 2.262 0 01-2.262 2.261z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M123.448 15.23H12.99a2.262 2.262 0 010-4.524h108.196v-4.78c0-.775-.628-1.402-1.402-1.402H5.926a1.41 1.41 0 00-1.402 1.402v7.042a2.262 2.262 0 01-4.524 0V5.926A5.933 5.933 0 015.926 0h113.843a5.933 5.933 0 015.926 5.926v7.042a2.262 2.262 0 01-2.247 2.261zM119.935 61.385H50.34a2.262 2.262 0 110-4.524h69.595a1.252 1.252 0 001.251-1.259V43.585H49.284a2.262 2.262 0 110-4.524h74.164a2.262 2.262 0 012.262 2.262v14.28a5.783 5.783 0 01-5.775 5.782zM62.893 106.764a2.262 2.262 0 01-2.262-2.262V98.47a2.262 2.262 0 014.523 0v6.032a2.262 2.262 0 01-2.261 2.262z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M62.855 89.89a2.262 2.262 0 01-2.262-2.261V73.538a2.262 2.262 0 012.262-2.262h39.204a2.262 2.262 0 012.262 2.262v13.36a2.262 2.262 0 01-4.524 0V75.8h-34.68v11.829a2.262 2.262 0 01-2.262 2.262zM116.316 89.16a2.262 2.262 0 01-2.262-2.262V70.115a2.262 2.262 0 014.524 0v16.798a2.262 2.262 0 01-2.262 2.246z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M119.935 107.812H50.34a2.262 2.262 0 110-4.524h69.595c.69 0 1.251-.56 1.251-1.252v-12.04H49.284a2.262 2.262 0 010-4.523h74.164a2.262 2.262 0 012.262 2.261v14.287a5.783 5.783 0 01-5.775 5.79z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M34.38 47.196H23.65a2.262 2.262 0 01-2.261-2.262V27.141a2.262 2.262 0 012.262-2.261h10.728a2.262 2.262 0 012.262 2.261v7.223a2.262 2.262 0 01-4.524 0v-4.96h-6.205v13.268h8.467a2.262 2.262 0 010 4.524zM34.38 93.608H23.65a2.262 2.262 0 01-2.261-2.262V73.538a2.262 2.262 0 012.262-2.262h10.728a2.262 2.262 0 012.262 2.262v7.223a2.262 2.262 0 01-4.524 0V75.8h-6.205v13.284h8.467a2.262 2.262 0 110 4.524z",
    fill: "#1B7"
  })));
};

var _default = SvgBApartmentPositive;
exports["default"] = _default;